import React from "react";
import { Typography, Space, Button } from "antd";
import { useConsultationSchedulingState } from "./State";
import translator from "@/translator";

const { Text } = Typography;
const t = translator("front_office.views.onboarding.amo_consultation_scheduling.");

const Welcome = () => {
  const { updateState } = useConsultationSchedulingState();

  return (
    <Space direction="vertical" size={32}>
      <img src="/onboarding/consultation_scheduling_1.svg" alt="" />
      <Space direction="vertical" size={8}>
        <Text strong>{t("welcome.title")}</Text>
        <Text>{t("welcome.description")}</Text>
      </Space>
      <Text>{t("welcome.assistant_help")}</Text>
      <Button
        onClick={() => updateState({ step: "form" })}
        className="ant-custom-btn"
        block
        type="primary"
      >
        {t("welcome.next_button")}
      </Button>
    </Space>
  );
};

export default Welcome;
